import { makeAutoObservable } from "mobx";
import Embarque from "../api/embarque/embarque";
import { getError } from "../util/util";
import { toJS } from "mobx";
import { getFormatDate } from "../../app/util/util";

export class EmbarqueStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loading = false;
  LastEmbarque = 0;
  embarquesStore = []
  embarquesFilter = []
  entity = null
  embarqueActual = [];

  setEntityEmbarque = (embarque) => {
    this.entity = embarque
  }

  onFilter = (value) => {
    this.embarquesFilter = this.embarquesStore.filter(
      (x) =>
        getFormatDate(x.fechaUltimoEstatus)?.toLowerCase().indexOf(value?.toLowerCase()) !== -1 ||
        x.numeroCartaPorte?.toLowerCase().indexOf(value?.toLowerCase()) !== -1 ||
        (x.comentario ?? '' ).toLowerCase().indexOf(value?.toLowerCase()) !== -1  ||
        x.estatus?.toLowerCase().indexOf(value?.toLowerCase()) !== -1 ||
        getFormatDate(x.fechaEstimadaLlegada).toLowerCase().indexOf(value?.toLowerCase()) !== -1
    );    
  };

  getEmbarqueById = async (idEmbarque) => {
    this.loading = true;
    try {
      const result = await Embarque.getEmbarqueById(idEmbarque)
      return Promise.resolve(result.data)
    } catch (error) {
      this.displayError(error)
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  };

  getEmbarques = async (data) => {
    this.loading = true;
    try {
      const result = await Embarque.getEmbarques(data);
      this.embarquesStore = result.data
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.loading = false;
    }
  };

  bloquearEmbarque = async (idEmbarque, esEditar) => {
    this.loading = true;
    try {
      this.LastEmbarque = idEmbarque;
      const result = await Embarque.bloquearEmbarque(idEmbarque, esEditar);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.loading = false;
    }
  }

  desbloquearEmbarque = async (idEmbarque, esEditar) => {
    this.loading = true;
    try {
      const result = await Embarque.desbloquearEmbarque(idEmbarque, esEditar);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.loading = false;
    }
  }

  leerAlertasUsuario = async (data) => {
    this.loading = true;
    try {
      const result = await Embarque.leerAlertasUsuario(data);
      //if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  cerrarAlertasUsuario = async (data) => {
    this.loading = true;
    try {
      const result = await Embarque.cerrarAlertasUsuario(data);
      //if (result.success) this.entity = result.data;
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  crearEmbarque = async (data) => {
    this.loading = true;
    try {
      const result = await Embarque.crearEmbarque(data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error)
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  }

  editarEmbarque = async (idEmbarque, data) => {
    this.loading = true;
    try {
      const result = await Embarque.editarEmbarque(idEmbarque, data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error)
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  }

  getEmbarqueFile = async (idEmbarque) => {
    this.loading = true;
    try {
      const result = await Embarque.getEmbarqueFile(idEmbarque);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError('Error al consultar el archivo del embarque')
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  }

  actualizarEstatusEmbarque = async (idEmbarque, model) => {
    this.loading = true;
    try {
      const result = await Embarque.actualizarEstatusEmbarque(idEmbarque, model);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.loading = false;
    }
  }

  getExcel = async (filter, name) => {
    this.loading = true;
    try {
      await Embarque.exporterExcel(filter, name);
      this.rootStore.alertStore.alertCreateSuccess("Exportado con Éxito");
    } catch (error) {
      this.displayError(error);
    } finally {
      this.loading = false;
    }
  };

  consultarComprobanteArchivo = async (idEmbarque) =>  {
    this.loading = true;
    try {
      const result = await Embarque.consultarComprobanteArchivo(idEmbarque);      
      return Promise.resolve(true);
    } catch (error) {
      this.rootStore.alertStore.alertError("Error al consultar archivo");        
      return Promise.resolve(false);
    } finally {
      this.loading = false;
    }
  }

  consultarComprobanteArchivoFile = async (idEmbarque) => {
    this.loading = true;
    try {
      const result = await Embarque.consultarComprobanteArchivoFile(idEmbarque);
      return Promise.resolve(result);
    } catch (error) {
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  }

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  };
}
